export default "__VITE_ASSET___UzKM4hC__"